import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import GoogleAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/GoogleAppIcon';

const GoogleReserveStrategy = {
  previewInfo: {
    name: 'Local Services Ads on Google',
    iconSvg: <GoogleAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Local Services Ads on Google',
    category: 'Get direct bookings directly Google searches',
    details: (
      <>
        Our online booking integration with Google Locals Services Ads gives customers the ability to see when you’re
        available so that they can book your services directly from your Local Services Ad. Save time responding to
        requests and ensure you never miss an online booking, even when customers can’t reach you by phone or
        email.{' '}
        <a href="http://help.housecallpro.com/en/articles/4005026-google-local-services-ads-integration-overview">
          Learn more.
        </a>
        <br />
        <br />
      </>
    ),
    iconSvg: <GoogleAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/vey1vdsxn1',
  },
  sellingPoints: {
    description: (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>How to get started:</Typography>
          <ul>
            You must be part of the
            <a href="https://ads.google.com/local-services-ads/#!/">
              <b> Google Guaranteed program </b>
            </a>
            to use the Housecall and Local Services Ads integration.
          </ul>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>Once you are Google Guaranteed:</Typography>
          <ul>
            <Typography paragraph>
              1. Set up your Online Booking Windows
            </Typography>
            <Typography paragraph>
              2. Enable the toggle on the app card, then configure your Google price list in your price book
            </Typography>
            <Typography paragraph>
              3. Login to your Google Account in Job Inbox
            </Typography>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            Check out this{' '}
            <a href="https://help.housecallpro.com/en/articles/7185374-connecting-housecall-pro-and-google-local-services-ads">
              help article
            </a> for step by step instructions on connecting your Google LSA to HCP
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
              ✅ Once you connect your Google LSA account, you will start seeing your bookings on your HCP calendar
              and in your Job Inbox channel with job details and customer information.
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <Typography align="center" variant="body2" color="textSecondary">
        While the integration is free, charges per lead from Local Services Ads still apply.
      </Typography>
    ),
  },
};

export default GoogleReserveStrategy;
